module.exports = __webpack_public_path__ + "img/left-bach.675a0738.png";